<template>
  <gj-modal
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal"
  >
   <template #header>导入产品</template>
   <template #content>
     <gj-upload
         :template-url="`/supply/inbound/downloadTemplate?type=${type}`"
         @uploadAfter="uploadAfter"
         :container-type="type"
         style="margin-bottom: 12px"
     >
       <template #tip>
         <span>只能上传xls/xlsx文件</span>
       </template>
     </gj-upload>
     <gj-import-alert
         :rules="getImportAlert()">
     </gj-import-alert>
   </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../../minxins";
  import {documentTypeEnum} from "../enum";
  import {importOtherInboundProduct, importOtherOutboundProduct} from "../../../../../api/warehouse";

  export default {
    name: "import-inbound-outbound",
    mixins: [modalMixIn, uploadMixin],
    props: {
      type: null,
      warehouseId: null,
    },
    data() {
      return {
        documentTypeEnum: documentTypeEnum,
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        const params = {
          attachmentId: attId,
          warehouseId: this.warehouseId
        };
        this.importHandleLoading = true;
        if (this.documentTypeEnum.INBOUND === this.type) {
          importOtherInboundProduct(params)
            .then((res) => {
              this.$gjImportHandle(res, uploadCb);
            }).catch(() => {
              uploadCb('error')
            }).complete(() => this.importHandleLoading = false)
        } else {
          importOtherOutboundProduct(params)
            .then((res) => {
              this.$gjImportHandle(res, uploadCb);
            }).catch(() => {
              uploadCb('error')
            }).complete(() => this.importHandleLoading = false)
        }

      },
      getImportAlert() {
        return this.type === this.documentTypeEnum.INBOUND ?
          ['模板中的表头不可更改，不能删除'] :
          ['模板中的表头不可更改，不能删除', '一次其它出库最多添加200条记录']
      }
    }
  }
</script>

<style scoped>

</style>
